export default __webpack_public_path__ + "static/media/mix-cool-people-mobile.f876a287.mp4";